import { render, staticRenderFns } from "./ViewEnergy.vue?vue&type=template&id=2231fb6f&scoped=true"
import script from "./ViewEnergy.vue?vue&type=script&lang=js"
export * from "./ViewEnergy.vue?vue&type=script&lang=js"
import style0 from "./ViewEnergy.vue?vue&type=style&index=0&id=2231fb6f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231fb6f",
  null
  
)

export default component.exports